import { Dispatch } from 'react';
import { get, post, put, remove } from 'communication/httpClient';
import {
  DELETE_PROFILE,
  LOAD_PROFILE,
  LOAD_PROFILES,
  LOAD_PROFILE_TYPES,
  PROFILES_LOADED,
  PROFILE_DELETED,
  PROFILE_LOADED,
  PROFILE_SAVED,
  PROFILE_TYPES_LOADED,
  RESET_PROFILES,
  RESET_SELECTED_PROFILE,
  SAVE_PROFILE,
  SYNC_FAILED,
} from './actionTypes';
import { IProfile, IProfilesAction, IProfilesActions } from './types';

export const getActions = (dispatch: Dispatch<IProfilesAction>): IProfilesActions => ({
  deleteProfile: async (id: string) => {
    dispatch({
      type: DELETE_PROFILE,
      payload: { id },
    });
    const { data, error } = await remove(`/api/account-profiles/${id}`);

    if (data) {
      dispatch({
        type: PROFILE_DELETED,
        payload: { id },
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadProfile: async (id: string) => {
    dispatch({
      type: LOAD_PROFILE,
      payload: { id },
    });
    const { data, error } = await get(`/api/account-profiles/${id}`);

    if (data) {
      dispatch({
        type: PROFILE_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadProfiles: async () => {
    dispatch({
      type: LOAD_PROFILES,
    });
    const { data, error } = await get('/api/account-profiles');

    if (data) {
      dispatch({
        type: PROFILES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  loadProfileTypes: async () => {
    dispatch({
      type: LOAD_PROFILE_TYPES,
    });
    const { data, error } = await get('/api/account-profiles/account-types');

    if (data) {
      dispatch({
        type: PROFILE_TYPES_LOADED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
  resetProfiles: () =>
    dispatch({
      type: RESET_PROFILES,
    }),
  resetSelectedProfile: () =>
    dispatch({
      type: RESET_SELECTED_PROFILE,
    }),
  saveProfile: async (profile: IProfile) => {
    dispatch({
      type: SAVE_PROFILE,
      payload: profile,
    });
    const handler = profile.header.externalId ? put : post;
    const { data, error } = await handler('/api/account-profiles', profile);

    if (data) {
      dispatch({
        type: PROFILE_SAVED,
        payload: data,
      });
    } else {
      dispatch({
        type: SYNC_FAILED,
        payload: error,
      });
    }
  },
});
